import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import rev from '../../images/rating.png'
import Switch from "react-switch";
import { deleteReview, editStatusReview, loadReviews } from '../../Redux/Actions/ActionReviews';
import ReactLoading from 'react-loading';
import './Reviews.css'

function Reviews() {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const allreviwes = useSelector(state => state.revieww.allreviwes)
    const loadingallreviwes = useSelector(state => state.revieww.loadingallreviwes)
    const [statusID, setstatusID] = useState(null);
    const [loadStatusID, setloadStatusID] = useState(false);
    useEffect(() => {
        dispatch(loadReviews());
        i18n.changeLanguage(localStorage.getItem('absherLang'));
    }, [])
    const handleDelete = (id) => {
        dispatch(deleteReview(id))
    }
    const editStatus = (id, is_active) => {
        setstatusID(id)
        let active;
        if (is_active == "0") {
            active = "1"
        } else {
            active = "0"
        }
        dispatch(editStatusReview(id, active, setloadStatusID))
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('reviews')}</h2>
                </div>
                <div className='allFea'  dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingallreviwes == false ? (
                            allreviwes.map((allrev) => {
                                return (
                                    <>
                                        {
                                            allrev.reviews != undefined ? (
                                                allrev.reviews.map((all) => {
                                                    return (
                                                        <div className='oneFea' key={all.id} >
                                                            {console.log(all)}
                                                            <img src={rev} style={{ borderRadius: "0px" }} />
                                                            <h3>{all.title}</h3>
                                                            <p>{all.review}</p>
                                                            <br></br>
                                                            <div className='action_rev' >
                                                                {
                                                                    (all.id === statusID && loadStatusID === true) ? (
                                                                        <ReactLoading type="cylon" color="#36ADB0" height={'85%'} width={'85%'} />
                                                                    ) : (
                                                                        <>
                                                                            {
                                                                                all.status === "0" ? (
                                                                                    <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={false} onChange={() => { editStatus(all.id, all.status) }} />
                                                                                ) : <Switch onColor='#36ADB0' checkedIcon={false} uncheckedIcon={false} height={20} width={40} handleDiameter={15} checked={true} onChange={() => { editStatus(all.id, all.status) }} />
                                                                            }
                                                                        </>
                                                                    )

                                                                }
                                                                <i className='fa fa-trash' onClick={() => handleDelete(all.id)} ></i>
                                                            </div>

                                                        </div>
                                                    )
                                                })
                                            ) : <></>
                                        }
                                    </>
                                )
                            })

                        ) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
            </main>
        </>
    )
}

export default Reviews